/* Added the following code for ux.ray using AI Agent. Aug 12, 2026. Code Start */
import React from "react";
import { Link } from "react-router-dom";
/* Code end. ray using AI Agent. Aug 12, 2026 */

const PERMISSION_ACTION_SUFFIXES = ["_c", "_u", "_v", "_w", "_t", "_k", "_y", "_q"];

export function stripLevelSuffix(slug) {
  if (!slug || typeof slug !== "string") return slug;
  return slug.replace(/-l\d+$/, "");
}

/* Added the following code for ux.ray using AI Agent. Aug 12, 2026. Code Start */
/**
 * Shown when a route or lesson has no permitted content — replaces blank white shells.
 */
export function AccessDenied({ message } = {}) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] px-6 py-12 text-center">
      <h1 className="text-xl font-semibold text-slate-800">Access denied</h1>
      <p className="mt-2 max-w-md text-slate-600">
        {message ||
          "You do not have permission to view this page. Contact an administrator if you need access."}
      </p>
      <Link
        to="/home"
        className="mt-6 inline-block rounded-md bg-[#044661] px-4 py-2 font-semibold text-white hover:bg-[#0891b2]"
      >
        Back to dashboard
      </Link>
    </div>
  );
}

/** True if any accordion block (What is it / Test / Check / Try / Quiz) is allowed. */
export function hasAnyBlockPermission(blockPermissions) {
  if (!blockPermissions || typeof blockPermissions !== "object") return false;
  return Object.values(blockPermissions).some(Boolean);
}
/* Code end. ray using AI Agent. Aug 12, 2026 */

function splitPermissionKey(key) {
  for (const suffix of PERMISSION_ACTION_SUFFIXES) {
    if (key.endsWith(suffix)) {
      return { base: key.slice(0, -suffix.length), suffix };
    }
  }
  return { base: key, suffix: "" };
}

/**
 * True when a role code stored as a unique menu slug grants a canonical pageSlug.
 * Example: ch-1-...-methods-tokensregex_v grants tokensregex_v.
 */
function chapterMenuSlugGrantsPageSlug(permBase, requiredBase) {
  if (!permBase || !requiredBase || permBase === requiredBase) return false;
  if (!/^ch-\d+-/i.test(permBase)) return false;
  return permBase.endsWith(`-${requiredBase}`);
}

/**
 * Matches permission keys across menu level suffixes
 * (e.g. retrieval-augmented-llm_v ↔ retrieval-augmented-llm-l3_v)
 * and unique chapter menu slugs used on learner roles
 * (e.g. ch-1-...-tokensregex_v ↔ tokensregex_v).
 */
export function hasPermission(permissions, permissionKey) {
  if (!Array.isArray(permissions) || !permissionKey) return false;
  if (permissions.includes(permissionKey)) return true;

  const { base, suffix } = splitPermissionKey(permissionKey);
  if (!suffix) return false;

  const normalizedBase = stripLevelSuffix(base);
  return permissions.some((perm) => {
    const parsed = splitPermissionKey(perm);
    if (parsed.suffix !== suffix) return false;
    const permBase = stripLevelSuffix(parsed.base);
    if (permBase === normalizedBase) return true;
    /* Added the following code for progress_tracking.ray using AI Agent. 17/08/2026. Code Start */
    return chapterMenuSlugGrantsPageSlug(permBase, normalizedBase);
    /* Code end. ray using AI Agent. 17/08/2026 */
  });
}
